import { useUtilityContext } from '@change-corgi/core-react/utilityContext';
import type { PaymentMethodUsage } from '@change-corgi/middle-end-gql-schema';

import { saveBraintreePaymentMethod } from '#src/app/shared/api/payments';
import type { PaymentType } from '#src/app/shared/utils/payments';

export type BraintreePaymentType = 'PAYPAL';

function isBraintreePaymentType(paymentType: string): paymentType is BraintreePaymentType {
	return paymentType === 'PAYPAL';
}

function mapPaymentType(paymentType: string): BraintreePaymentType | null {
	const uppercasePaymentType = paymentType.toUpperCase();
	if (isBraintreePaymentType(uppercasePaymentType)) {
		return uppercasePaymentType;
	}
	return null;
}

export function useBraintreePermanentPaymentMethod(): (params: {
	paymentType: PaymentType;
	token?: string;
	tokenType?: 'temporary' | 'permanent';
	usage: PaymentMethodUsage;
	email: string;
}) => Promise<void> {
	const utilityContext = useUtilityContext();

	return async (params): Promise<void> => {
		const { token, usage, email, paymentType } = params;
		const paymentMethod = { id: token };
		const mappedPaymentType = mapPaymentType(paymentType);
		if (paymentMethod.id && mappedPaymentType) {
			await saveBraintreePaymentMethod({
				token: paymentMethod.id,
				email,
				usage,
				utilityContext,
				paymentType: mappedPaymentType,
			});
		}
	};
}
